module.exports = __webpack_public_path__ + "static/media/league-manager-screenshot.e329bbbd.png";